"use server";
import { revalidatePath } from "next/cache";
import { mkdir, writeFile, unlink } from "node:fs/promises";
import { randomUUID } from "node:crypto";
import { join } from "node:path";
import { db } from "@/lib/db";
import { requireViewer } from "@/lib/auth";
export async function createItem(data: FormData) {
 const viewer=await requireViewer();
 const title=String(data.get("title")??"").trim();
 if(!title || title.length>160) return {error:"請輸入 1–160 字的標題"};
 await db.query("INSERT INTO demo_items(owner_id,title,kind) VALUES($1,$2,'case')",[viewer.id,title]);
 revalidatePath("/kit"); return {success:true};
}
export async function uploadDocument(data:FormData) {
 const viewer=await requireViewer();
 const file=data.get("file");
 if(!(file instanceof File) || file.size===0) return {error:"請選擇文件"};
 if(file.size>5*1024*1024) return {error:"文件上限 5 MB"};
 if(!/\.(txt|md|csv|pdf)$/i.test(file.name)) return {error:"支援 TXT、Markdown、CSV、PDF"};
 const dir=process.env.UPLOAD_DIR || "/home/user/dev-demo-data/uploads";
 await mkdir(dir,{recursive:true});
 const path=join(dir,randomUUID());
 await writeFile(path,Buffer.from(await file.arrayBuffer()),{mode:0o600});
 try { await db.query("INSERT INTO demo_items(owner_id,title,kind,file_path,original_name) VALUES($1,$2,'document',$3,$4)",[viewer.id,file.name.slice(0,160),path,file.name.slice(0,255)]); }
 catch(error) {await unlink(path); throw error;}
 revalidatePath("/kit"); return {success:true};
}
